export default __webpack_public_path__ + "static/media/motor_rpm_new.29a43416.svg";